export const PreProcessApplicantPostData = (data) => {
  var modifiedData = { ...data };
  delete modifiedData.physical;
  delete modifiedData.heard;
  delete modifiedData.read;
  return { ...modifiedData, ...data?.physical, ...data?.heard, ...data?.read };
};
